module.exports = {
	"it": {
		"hqm": {
			"support-button": "Ottieni supporto",
			"support-page": {
				"create-ticket": {
					"title": "Ottieni supporto",
					"instructions": "Invia qui sotto una richiesta e ti ricontatteremo.",
					"fields": {
						"mid": {
							"label": "Seleziona negozio",
							"validation": "Negozio necessario"
						},
						"topic": {
							"question": "A cosa si riferisce la sua domanda?",
							"label": "Seleziona un argomento",
							"validation": "Argomento necessario",
							"options": {
								"orders": "Ordini",
								"settlements": "Liquidazioni",
								"agreements": "Accordi",
								"technical_issues": "Problemi tecnici",
								"others": "Altri"
							}
						},
						"subject": {
							"label": "Oggetto",
							"validation": "Oggetto necessario"
						},
						"description": {
							"label": "Messaggio",
							"validation": "Descrizione necessaria"
						},
						"attachment": {
							"label": "Aggiungi allegati",
							"button": "Carica",
							"info": "Aggiungere schermate ci aiuterà a risolvere questo problema più rapidamente.",
							"supportedFileTypes": "Tipi di file supportati: .png, jpg, .pdf",
							"error": "La dimensione totale dei file non può eccedere i 15 MB"
						}
					},
					"submit": "Invia richiesta",
					"service-unavailable-error": "Oh, no! Si è verificato un problema, riprova in alcuni minuti. Se il problema persiste, {link} per richiedere assistenza.",
					"contact-page-link": "contattaci"
				},
				"view-ticket": {
					"title": "Completato tutto!",
					"details": "Abbiamo ricevuto la tua richiesta è ti ricontatteremo a breve. Ecco i dati della richiesta:",
					"ticket": "Richiesta n. {ticketId}",
					"email": "Email: {email}",
					"status": "Puoi tracciare lo stato nella nostra pagina di Supporto",
					"track": "Traccia stato"
				}
			},
			"popup": {
				"yes": "Sì",
				"no": "No",
				"somethingElse": "Ho bisogno di aiuto con qualcos’altro"
			},
			"header": {
				"homeLink": "Ripristina"
			},
			"home": {
				"greeting": "Buongiorno {givenName}! Come possiamo essere d’aiuto?",
				"topics": "In cosa possiamo aiutarti?"
			},
			"topics": {
				"expandButton": "Altro"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "Siamo spiacenti che questo non sia stato d’aiuto. Magari alcuni di questi articoli potrebbero aiutarti?",
				"stillQuestionsTitle": "Hai ancora dei dubbi?",
				"stillQuestionsParagraph": "Puoi anche contattarci direttamente.",
				"contactButton": "Contattaci"
			},
			"feedback": {
				"title": "È stata una risposta utile?",
				"optionYes": "Sì, è stata utile",
				"optionNo": "No, ho bisogno di ulteriore aiuto",
				"positiveFeedback": "Grazie per il tuo feedback positivo, questo ci aiuta molto ad offrire articoli più pertinenti per il futuro."
			},
			"freeTextFeedback": {
				"title": "Aiutaci a migliorare",
				"placeholder": "Perché non hai trovato utili questi contenuti?",
				"submitButton": "Invia",
				"feedbackMessage": "Grazie per il tuo feedback, questo ci aiuta molto ad offrire articoli più pertinenti per il futuro."
			},
			"relatedContent": {
				"title": "Contenuti correlati"
			},
			"search": {
				"buttonLabel": "Ricerca",
				"input": "Ricerca articoli…",
				"loading": "Caricamento…",
				"results": {
					"contact": "Non riesci a trovare l’aiuto di cui hai bisogno?",
					"empty": "Spiacenti, non sono stati trovati risultati per la tua richiesta. Prova a cercare un termine differente.",
					"singleTopicFound": "Abbiamo trovato 1 argomento",
					"multipleTopicsFound": "Abbiamo trovato {count} argomenti",
					"singleArticleFound": "Abbiamo trovato 1 articolo",
					"multipleArticlesFound": "Abbiamo trovato {count} articolo"
				}
			},
			"contact": {
				"title": "Contatta",
				"channelsIntro": "Contattaci così potremo essere d’aiuto.",
				"businessDetailsTitle": "I dati della tua attività",
				"businessDetailsName": "Nome attività",
				"businessDetailsEmail": "Email",
				"businessDetailsMid": "Merchant ID",
				"phone": {
					"title": "Chiamaci",
					"paragraph": "Puoi chiamarci durante l’orario di lavoro nei giorni infrasettimanali. Se ti trovi in Svezia o nel Regno Unito, puoi anche chiamarci durante i fine settimana, tra le 10:00 e le 16:00."
				},
				"chat": {
					"title": "Chatta con noi",
					"paragraph": "La maniera più veloce e semplice per raggiungere il Supporto. La nostra chat è attualmente aperta.",
					"button": "Apri chat"
				},
				"email": {
					"title": "Scrivici un’email",
					"paragraph": "Invia un’email, risponderemo il prima possibile."
				}
			},
			"errorBoundary": {
				"title": "Si è verificato un problema",
				"message": "Siamo molto spiacenti, si è verificato un errore. Puoi cliccare sul bottone sottostante per resettare e chiudere questa barra laterale.",
				"resetButton": "Ripristina",
				"errorId": "ID errore: {errorId}"
			},
			"tour": {
				"prev": "Precedente",
				"next": "Prossimo",
				"done": "Fatto"
			},
			"notAvailableMobile": {
				"title": "Non disponibile",
				"buttonBack": "Indietro",
				"paragraph": "Questo contenuto non è disponibile per il tuo dispositivo. Prova ad aprirlo su un dispositivo dallo schermo più grande, quale un computer."
			},
			"shareButton": {
				"title": {
					"article": "Condividi un link dettagliato a questo articolo",
					"topic": "Condividi un link dettagliato a questo argomento",
					"tour": "Condividi un link dettagliato a questa visita"
				},
				"radioItemHome": "Home dell’app",
				"descriptionHome": "Apre l’articolo di aiuto sulla pagina Home del Portale Merchant",
				"radioItemCurrent": "Pagina attuale",
				"descriptionCurrent": "Apre l’articolo di aiuto sulla pagina attuale"
			}
		},
		"orientation": {
			"title": "Impara a…"
		},
		"core": {
			"alert": {
				"message": "Si è verificato un problema. Riprova un’altra volta.",
				"correlationIdLabel": "ID di correlazione:"
			},
			"header": {
				"title": "Portale merchant"
			},
			"usermenu": {
				"language": "Seleziona",
				"country": "Paese",
				"timezone": "Fuso orario",
				"logout": "Logout",
				"profile": "Profilo",
				"changeProfile": "Modifica",
				"tooltip": "Il tuo profilo"
			},
			"appsmenu": {
				"defaultTooltip": "Le tue app",
				"initialTooltip": "Trova qui le tue app.",
				"newAppsTooltip": "Abbiamo nuove app per te!"
			},
			"helpful-question-mark": {
				"helpLabel": "Aiuto"
			},
			"languages": {
				"da": "Danese",
				"de": "Tedesco",
				"en": "Inglese",
				"en_GB": "English (GB)",
				"en_US": "English (US)",
				"es": "Spagnolo",
				"fi": "Finlandese",
				"fr": "Francese",
				"it": "Italiano",
				"nl": "Olandese",
				"no": "Norvegese",
				"sv": "Svedese"
			},
			"countries": {
				"de": "Germania",
				"dk": "Danimarca",
				"fi": "Finalndia",
				"gb": "Gran Bretagna",
				"nl": "Paesi Bassi",
				"no": "Norvegia",
				"se": "Svezia",
				"us": "Stati Uniti"
			},
			"selectLanguage": {
				"title": "Seleziona la lingua",
				"paragraph": "Questa sarà la lingua predefinita.",
				"submit": "OK"
			},
			"selectCountry": {
				"title": "Seleziona il paese",
				"paragraph": "Questo sarà il paese predefinito.",
				"submit": "OK"
			},
			"updateProfile": {
				"title": "Aggiorna dettagli",
				"submit": "OK",
				"emailLabel": "Indirizzo email",
				"firstNameLabel": "Nome",
				"lastNameLabel": "Cognome",
				"resetPasswordLabel": "Ripristina password",
				"resetPasswordSuccessLabel": "Email per resettare la password inviata",
				"resetPasswordErrorLabel": "Errore nell’inviare l’email per resettare la password",
				"error": "Aggiornamento dei dettagli non riuscito"
			},
			"footer": {
				"copyright": {
					"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Tutti i diritti riservati",
					"oc": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
					"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215"
				},
				"terms": "Termini e condizioni"
			},
			"accessDenied": {
				"title": "Per questa pagina è necessario un accesso aggiuntivo.",
				"message": "Contatta il tuo amministratore o Klarna con qualsiasi domanda."
			},
			"midSelector": {
				"label": "Negozio"
			},
			"storeSelector": {
				"label": "Negozio"
			},
			"storesSelector": {
				"closeText": "Fatto",
				"closeTextWithSelection": "Applica # selezione/i",
				"deselectAllOptionText": "Cancella selezione",
				"emptyStateText": "Nessun negozio trovato",
				"label": "Negozi",
				"searchFieldLabel": "Ricerca per negozio",
				"selectAllOptionText": "Seleziona tutti i negozi",
				"selectedAllText": "Tutti i negozi",
				"selectedText": "# negozi"
			},
			"pagination": {
				"ofLabel": "di",
				"noResultsLabel": "Nessun risultato"
			},
			"dateRangePicker": {
				"startLabel": "Data d’inizio",
				"endLabel": "Data di termine",
				"months": {
					"january": "Gennaio",
					"february": "Febbraio",
					"march": "Marzo",
					"april": "Aprile",
					"may": "Maggio",
					"june": "Giugno",
					"july": "Luglio",
					"august": "Agosto",
					"september": "Settembre",
					"october": "Ottobre",
					"november": "Novembre",
					"december": "Dicembre"
				},
				"weekDaysShort": {
					"monday": "L",
					"tuesday": "M",
					"wednesday": "M",
					"thursday": "G",
					"friday": "V",
					"saturday": "S",
					"sunday": "D"
				}
			},
			"appIcon": {
				"newLabel": "NOVITÀ"
			},
			"appCategory": {
				"dayToDay": "Per la tua quotidianità",
				"nko": "Klarna Online",
				"tools": "Strumenti",
				"preferences": "Preferenze"
			},
			"apps": {
				"home-fe": {
					"title": "Home"
				},
				"nko-app": {
					"title": "App online Klarna"
				},
				"orders-fe": {
					"title": "Ordini",
					"description": "Ricerca e gestisci i tuoi ordini da Klarna.",
					"nkoLinkText": "Accedi ai vecchi ordini"
				},
				"nko-orders": {
					"title": "Ordini (KO)",
					"description": "Ricerca e gestisci i tuoi ordini effettuati tramite Klarna Online."
				},
				"settlements-fe": {
					"title": "Liquidazioni",
					"description": "Guarda le tue transazioni e genera rapporti per la riconciliazione.",
					"nkoLinkText": "Accedi a rapporti più vecchi"
				},
				"nko-settlements": {
					"title": "Liquidazioni (KO)",
					"description": "Trova rapporti di ordini e pagamenti da Klarna Online."
				},
				"logs-app-fe": {
					"title": "Log",
					"description": "Ricerca log API per risolvere i problemi di integrazione."
				},
				"users-fe": {
					"title": "Utenti",
					"description": "Invita nuovi utenti e gestisci utenti già esistenti nel Portale."
				},
				"settings-fe": {
					"title": "Impostazioni",
					"description": "Richiedi le tue credenziali API per Klarna e gestisci le impostazioni del negozio."
				},
				"nko-settings": {
					"title": "Impostazioni (KO)",
					"description": "Gestisci le impostazioni del tuo negozio, i rapporti e i dettagli di contatto."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Crea nuovi ordini con la soluzione Klarna In‑store."
				},
				"products-fe": {
					"title": "Prodotti",
					"description": "Ti guida nel cammino per ottenere il massimo da Klarna."
				},
				"upstream-fe": {
					"title": "On-site messaging",
					"description": "Aumenta le vendite con offerte finanziarie su misura e personalizzate."
				},
				"lending-fe": {
					"title": "Prestito ai commercianti",
					"description": "Finanziamento aziendale, reso semplice."
				},
				"branding-fe": {
					"title": "Branding",
					"description": "Prendi il controllo su come il tuo marchio è presentato da Klarna."
				},
				"disputes-fe": {
					"title": "Contestazioni",
					"description": "Gestisci le contestazioni."
				},
				"logistics-fe": {
					"title": "Logistica",
					"description": "Gestisci tutta la logistica in un solo posto."
				},
				"ob-transactions-fe": {
					"title": "Transazioni",
					"description": "Transazioni bancarie aperte"
				},
				"developers": {
					"title": "Sviluppatori"
				},
				"product-upgrade-fe": {
					"title": "Aggiornamento del prodotto"
				},
				"marketing": {
					"title": "Marketing",
					"description": "Prendi qui le risorse di marketing per far crescere il tuo business."
				},
				"business-card-fe": {
					"title": "Carta Business",
					"description": "Prossimamente"
				},
				"support": {
					"title": "Supporto",
					"description": "Controlla e gestisci le tue richieste di supporto."
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Indietro"
				}
			},
			"errorBoundary": {
				"contact": "Prova ad aggiornare la pagina. <br /> Se l’errore persiste, contatta il <a href='https://www.klarna.com/merchant-support' target='_blank'>Supporto Merchant</a> fornendo l’ID <strong>{errorId}</strong>",
				"errorDescription": "ID errore - {errorId}",
				"reloadButton": "Aggiorna",
				"title": "Purtroppo si è verificato un errore"
			},
			"maintenance": {
				"pageTitle": "Manutenzione",
				"title": "Il Portale merchant è attualmente in fase di manutenzione programmata",
				"summary": "Torneremo presto online",
				"scheduledSummary": "Torneremo alle {until}"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "Una delle più importanti giornate di vendita al dettaglio è quasi alle porte. Durante il Black Friday, saremo qui per offrirti le statistiche di vendita in tempo reale. Nel frattempo, prepariamoci al successo!",
				"countdown": "Cominciamo tra #dg #ho #mm #ss…",
				"box1": {
					"title": "Spesa 3,5 volte maggiore*",
					"text": "L’anno scorso, la spesa effettuata dagli acquirenti Klarna* è stata in media 3,5 volte maggiore nel Black Friday che in qualsiasi altro giorno dell’anno.",
					"footnote": "*Media relativa a tutte le categorie di commercianti Klarna e regioni."
				},
				"box2": {
					"title": "Volume delle vendite 2,5 volte maggiore*",
					"text": "L’anno scorso, i commercianti Klarna hanno generato un volume delle vendite 2,5 volte maggiore durante il Black Friday rispetto a qualsiasi altro giorno dell’anno.",
					"footnote": "*Media relativa a tutte le categorie di commercianti Klarna e regioni."
				},
				"sectionTitle": "Aumentiamo le tue vendite nel Black Friday",
				"marketing": {
					"title": "Pubblicizza la tua attività prima e durante il Black Friday",
					"text": "Attira un maggior numero di acquirenti nel tuo negozio durante la stagione degli acquisti del Black Friday con queste risorse gratuite per i social media e le campagne email."
				},
				"branding": {
					"title": "Renditi visibile nella Klarna app",
					"text": "12 milioni di acquirenti utilizzano Klarna app ogni mese. Fatti notare nell’app durante questo Black Friday aggiungendo e aggiornando le informazioni sul tuo brand qui nel il Portale merchant."
				},
				"cta": "Inziare",
				"close": "Chiudi"
			},
			"v2": {
				"title": "Black Friday week",
				"orderVolume": "Volume vendite",
				"orderCountTitle": "Ordini creati",
				"orderCount": "{count} ordini",
				"box": {
					"title": "Vuoi aumentare ulteriormente il tasso di conversione?",
					"subtitle1": "On-site messaging",
					"subtitle2": "Messaggistica promozionale che educa.",
					"text": "Il nostro strumento di On-site messaging contribuisce ad aumentare le vendite e il valore medio degli ordini con messaggi promozionali. Fai sapere ai clienti quali sono le loro opzioni di pagamento non appena arrivano sul tuo sito, e attraverso il processo d’acquisto.",
					"cta": "Inziare"
				},
				"selector": {
					"done": "Fatto",
					"applySelection": "Applica # selezione/i",
					"selectAll": "Seleziona tutto",
					"allOptions": "Opzioni tutte selezionate",
					"someOptions": "# opzioni selezionate",
					"storeMultiSelectLabel": "Scegli # negozi",
					"allStores": "Tutti i negozi"
				},
				"currencyLabel": "Scegli valuta",
				"storeLabel": "Scegli negozio"
			},
			"v3": {
				"title": "Black Friday week",
				"text": "Queste sono le vendite durante una delle più importanti settimane dell'anno",
				"summaryTitle": "Riepilogo",
				"orderVolume": "Volume totale",
				"orderCount": "Totale ordini",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "rispetto allo stesso giorno della settimana scorsa",
				"tabs": {
					"monday": "Lunedì",
					"tuesday": "Martedì",
					"wednesday": "Mercoledì",
					"thursday": "Giovedì",
					"blackFriday": "Black Friday",
					"saturday": "Sabato",
					"sunday": "Domenica",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};